if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.addEventListener('click', this.onClickHandler.bind(this));
      }

      onClickHandler(e) {
        if (e.target.closest('.product-form__dynamic')) {
          let parent = e.target.closest('.product-form__dynamic');

          if (!parent.classList.contains('enabled')) {
            parent.classList.add('error');

            setTimeout(() => {
              parent.classList.remove('error');
            }, 3000);
          }
        }
      }

      onSubmitHandler(evt) {
        this.submitButton = this.querySelector('[type="submit"]');

        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            const quickAddModal = this.closest('quickview-container');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (!customElements.get('product-login')) {
  customElements.define(
    'product-login',
    class ProductLogin extends HTMLElement {
      constructor() {
        super();

        this.loginContainer = this.querySelector('.product__account-content--login');
        this.recoverContainer = this.querySelector('.product__account-content--recover');
        this.registerContainer = this.querySelector('.product__account-content--register');

        this.recoverCancel = this.querySelector('[id^="ProductAccountRecoverCancel"]');
        this.registerCancel = this.querySelector('[id^="ProductAccountRegisterCancel"]');
        this.recoverShow = this.querySelector('[id^="ProductAccountRecoverShow"]');
        this.registerShow = this.querySelector('[id^="ProductAccountRegisterShow"]');

        if (this.recoverCancel) {
          this.recoverCancel.addEventListener('click', this.onRecoverCancel.bind(this));
        }

        if (this.registerCancel) {
          this.registerCancel.addEventListener('click', this.onRegisterCancel.bind(this));
        }

        if (this.recoverShow) {
          this.recoverShow.addEventListener('click', this.onRecoverShow.bind(this));
        }

        if (this.registerShow) {
          this.registerShow.addEventListener('click', this.onRegisterShow.bind(this));
        }
      }

      onRecoverCancel(e) {
        e.preventDefault();

        this.registerContainer.classList.add('hidden');
        this.recoverContainer.classList.add('hidden');
        this.loginContainer.classList.remove('hidden');
      }

      onRegisterCancel(e) {
        e.preventDefault();

        this.registerContainer.classList.add('hidden');
        this.recoverContainer.classList.add('hidden');
        this.loginContainer.classList.remove('hidden');
      }

      onRecoverShow(e) {
        e.preventDefault();

        this.loginContainer.classList.add('hidden');
        this.recoverContainer.classList.remove('hidden');
      }

      onRegisterShow(e) {
        e.preventDefault();

        this.loginContainer.classList.add('hidden');
        this.registerContainer.classList.remove('hidden');
      }
    }
  );
}
